import * as types from "./notificationsTypes";

// lấy danh sách noti
export const getNotificationOnPage = payload => {
  return {
    type: types.GET_NOTIFICATION_ON_PAGE,
    payload
  };
};

// Check noti đã đọc
export const checkReadNoti = id => {
  return {
    type: types.CHECK_READ_NOTI,
    id
  };
};

export const getNotification = payload => {
  return {
    type: types.GET_NOTIFICATION,
    payload
  };
};

export const getNotificationSuccess = payload => {
  return {
    type: types.GET_NOTIFICATION_SUCCESS,
    payload
  };
};

export const getNotificationFail = payload => {
  return {
    type: types.GET_NOTIFICATION_FAIL,
    payload
  };
};

export const getMoreNotification = payload => {
  return {
    type: types.GET_MORE_NOTIFICATION,
    payload
  };
};

export const getMoreNotificationSuccess = payload => {
  return {
    type: types.GET_MORE_NOTIFICATION_SUCCESS,
    payload
  };
};

export const getMoreNotificationFail = payload => {
  return {
    type: types.GET_MORE_NOTIFICATION_FAIL,
    payload
  };
};

export const updateReadNotification = payload => {
  return {
    type: types.UPDATE_READ_NOTIFICATION,
    payload
  };
};

export const deleteAllNotification = payload => {
  return {
    type: types.DELETE_ALL_NOTIFICATION,
    payload
  };
};

export const deleteNoti = payload => {
  return {
    type: types.DELETE_NOTIFICATION,
    payload
  };
};

export const clearNotificationAtStore = () => {
  return {
    type: types.CLEAR_NOTIFICATION_AT_STORE
  };
};

export const markAllNotiAsRead = () => {
  return {
    type: types.MARK_ALL_NOTI_AS_READ
  };
};

export const getNotificationByTypeSuccess = payload => {
  return {
    type: types.GET_NOTIFICATION_BY_TYPE_SUCCESS,
    payload
  };
};

export const getNotificationByTypeFail = payload => {
  return {
    type: types.GET_NOTIFICATION_BY_TYPE_FAIL,
    payload
  };
};
